<template>
<v-main>
    <v-flex row wrap mt-3 px-5>
        <h1>
        <p class="text-sm-left font-weight-bold">Cadastrar Recepcionista </p>
         <!-- {{recepcionista}} -->
        </h1>
    </v-flex>

<v-flex row wrap mt-3 px-5>
<form row>
   <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="10"
      :rules="nameRules"
      label="Name"
      required
    ></v-text-field>

    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      required
    ></v-text-field>

    <v-select
      v-model="select"
      :items="items"
      :rules="[v => !!v || 'Item is required']"
      label="Item"
      required
    ></v-select>

    <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'Você deve concordar para continura!']"
      label="Do you agree?"
      required
    ></v-checkbox>

    <v-btn @click="">submeter</v-btn>
    <v-btn @click="clear">limpar</v-btn>

  </v-form>
  </form>

</v-flex>

</v-main>

</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'CadastrarRecepcionista',
  data: () => ({
    recepcionista: {
      name: '',
      email: '',
      password: '',
      unidade: ''
    },
    prioridade: false
  }),
  components: {
    // HelloWorld
  },
  created () {
    console.log('created cadastr...')
  },
  methods: {
    clear () {
      this.recepcionista.name = ''
      this.recepcionista.email = ''
      this.recepcionista.password = null
      this.recepcionista.unidade = null
      this.prioridade = false
    }
  },
  computed: {
    teste () {
      console.log('teste')
    }
  }
}
</script>

<style  scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>
